import { DatePicker, Input, InputNumber, Select, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faXmark } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import { Filter as FilterState } from "./Withdraw";

const STATUS_OPTIONS = [
    { label: "Chờ duyệt", value: 1 },
    { label: "Đã xử lý", value: 2 },
    { label: "Đã huỷ", value: 3 },
];

const DATE_PRESETS = [
    { label: "Hôm nay", value: [dayjs().startOf("day"), dayjs().endOf("day")] },
    {
        label: "Hôm qua",
        value: [
            dayjs().subtract(1, "day").startOf("day"),
            dayjs().subtract(1, "day").endOf("day"),
        ],
    },
    { label: "7 ngày qua", value: [dayjs().subtract(6, "day").startOf("day"), dayjs().endOf("day")] },
    { label: "30 ngày qua", value: [dayjs().subtract(29, "day").startOf("day"), dayjs().endOf("day")] },
    { label: "Tháng này", value: [dayjs().startOf("month"), dayjs().endOf("month")] },
    {
        label: "Tháng trước",
        value: [
            dayjs().subtract(1, "month").startOf("month"),
            dayjs().subtract(1, "month").endOf("month"),
        ],
    },
];

type Props = {
    filter: FilterState;
    setFilter: React.Dispatch<React.SetStateAction<FilterState>>;
};

function FilterCom({ filter, setFilter }: Props) {
    const hasActiveFilter =
        filter.status || filter.startDate || filter.endDate || filter.userId || filter.minAmount;

    const onSelectStatus = (value: number) =>
        setFilter((prev) => ({ ...prev, status: value, page: 1 }));

    const onSelectDate = (value: any) => {
        if (!value) {
            setFilter((prev) => ({ ...prev, startDate: undefined, endDate: undefined, page: 1 }));
            return;
        }
        setFilter((prev) => ({
            ...prev,
            startDate: value[0].startOf("day").unix(),
            endDate: value[1].endOf("day").unix(),
            page: 1,
        }));
    };

    const onSearchUserId = (e: React.ChangeEvent<HTMLInputElement>) => {
        const userId = e.target.value.trim() ? Number(e.target.value.trim()) : undefined;
        setFilter((prev) => ({ ...prev, userId, page: 1 }));
    };

    const onChangeMinAmount = (value: number | null) =>
        setFilter((prev) => ({ ...prev, minAmount: value || undefined, page: 1 }));

    const onClearAll = () =>
        setFilter({
            limit: 10,
            page: 1,
            status: undefined,
            startDate: undefined,
            endDate: undefined,
            userId: undefined,
            minAmount: undefined,
        });

    return (
        <div className="flex flex-wrap gap-2 items-center">
            <Select
                onChange={onSelectStatus}
                options={STATUS_OPTIONS}
                className="w-36"
                allowClear
                placeholder="Trạng thái"
                value={filter.status}
            />
            <DatePicker.RangePicker
                onChange={onSelectDate}
                placeholder={["Từ ngày", "Đến ngày"]}
                allowClear
                presets={DATE_PRESETS as any}
                value={
                    filter.startDate && filter.endDate
                        ? [dayjs.unix(filter.startDate), dayjs.unix(filter.endDate)]
                        : undefined
                }
            />
            <Input
                placeholder="User ID"
                prefix={
                    <FontAwesomeIcon icon={faSearch} className="text-content-3 text-xs" />
                }
                className="w-32"
                onChange={onSearchUserId}
                value={filter.userId ?? ""}
                allowClear
            />
            <InputNumber
                placeholder="Số tiền tối thiểu"
                className="w-40"
                onChange={onChangeMinAmount}
                value={filter.minAmount}
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                parser={(value) => Number(value?.replace(/,/g, "") || 0)}
                min={0}
            />
            {hasActiveFilter && (
                <Button
                    size="small"
                    icon={<FontAwesomeIcon icon={faXmark} className="text-xs" />}
                    onClick={onClearAll}
                    className="text-content-3"
                >
                    Xoá lọc
                </Button>
            )}
        </div>
    );
}

export default FilterCom;
